module.exports = __webpack_public_path__ + "img/luckytime.1f140530.gif";